'use strict';

import moment from 'moment';

const key = "CACHED::::_";

export class CachedStorageService {
  static $inject = ['localStorage'];

  constructor(localStorage) {
    this.localStorage = localStorage;
  }

  retrieve(storageName, getExpired) {
    let value = this.localStorage.getObject(key + storageName);

    if (value === null)
      return null;

    if (moment(value.expireAt) < moment() && !getExpired) {
      return null;
    }

    return value.obj;
  }

  remove(storageName) {
    this.localStorage.setObject(key + storageName, null);
  }

  store(storageName, storageValue, time) {
    this.localStorage.setObject(key + storageName, {
      expireAt: moment().add(time, 'minutes'),
      obj: storageValue
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/cacheStorage.js